import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '../../core/services/maintenance-service';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.html',
  styleUrl: './maintenance-banner.scss',
  standalone: false
})
export class MaintenanceBanner implements OnInit {
  public isVisible = false;
  public message = 'Rackspace Technology will be performing a planned maintenance on Saturday, May. 16th starting at 8am CST until  5pm CST. During this time, you will be unable to sign up. We apologize for any inconvenience and appreciate your understanding';

  private intervalId: any;

  constructor(private maintenanceService: MaintenanceService) { }

  ngOnInit() {
    this.checkStatus();
    this.intervalId = setInterval(() => this.checkStatus(), 30 * 1000);
    //this.isVisible = this.maintenanceService.shouldShowBanner();
    console.log('this.isVisible', this.isVisible);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  checkStatus() {
    this.isVisible = this.maintenanceService.isActive();
  }

  dismissBanner() {
    this.isVisible = false;
  }
}
